import { useNavigate } from "react-router-dom";
import styled from "@emotion/styled/macro";
import { useUserContext } from "../../../context/userContext";
import useInput from "../../../hooks/useInput";
import Button from "../../common/button/Button";
import FormField from "../../common/formField/FormField";
import type { User } from "../../../context/userContext";
import qrCodeGraphic from "../../../img/scan-qr-code.png";
import useCustomerClient from "../../../data/customerSource";
import KovaUtil from "../../../kova/kovautil";
import {useCommunityContext} from "../../../context/communityContext";

const Container = styled.div`
    box-sizing: border-box;
    width: 100%;
  .buttons {
    display: flex;
    flex-direction:row;
    justify-content: space-around;
    gap: 10px;
    > * {
      
      flex-grow: 1;
      
    }
  }
`

const Form = styled.form`
    & button {
        margin-top: 32px;
    }
`

const Divider = styled.div`
    display: flex;
    justify-content: center;
    margin: 32px 0;
    position: relative;

    & > div:first-child {
        background: #848484;
        height: 1px;
        position: absolute;
        top: 50%;
        transform: translate-y(-50%);
        width: 100%;
        z-index: -1;
    }
    & > div:last-child {
        background: #fff;
        color: #848484;
        display: inline-block;
        font-size: 1rem;
        font-weight: 500;
        padding: 0 32px;
    }
`

const QRCodeButton = styled.button`
    background: none;
    border: none;
    display: block;
    margin: auto;
`

const LogInSearch: React.FC<{onSkipLogin: (communityId:string) => void, onCreateAccount: (communityId:string, phone:string) => void, onAccountFound: (communityId:string) => void, skipText: string}> = (props) => {
    const { onSkipLogin, onAccountFound, onCreateAccount, skipText } = props;
    //const navigate = useNavigate();
    const { setUser } = useUserContext();
    const customerClient = useCustomerClient();

    const { onChange: onPhoneChange, value: phone } = useInput('');

    const { community } = useCommunityContext();
    if (community === undefined) throw "Unknown community!";
    const queryCustomerContacts = async (phone: string): Promise<User[]> => {
        //TODO: Replace mock with API

        const retval = await customerClient.findCustomerByPhone(community, phone);
        if (retval === null) return [];
        return [retval];


    }

    const skipLogin = () => {
        onSkipLogin(community);
        //navigate("/welcome");
    }
    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        const customerContacts = await queryCustomerContacts(KovaUtil.formatPhoneNumber(phone));
        const foundCustomer = customerContacts[0];
        
        if (foundCustomer) {
            setUser(foundCustomer);
            onAccountFound(community);
            //navigate('account-found');
        } else {
            onCreateAccount(community, phone);
            //navigate('create-account')
        }
    }

    const onPhoneChangeWithValidate = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        event.preventDefault();
        event.currentTarget.value = KovaUtil.formatPhoneNumber(event.currentTarget.value);

        onPhoneChange(event)
    };



    return (
        <Container>
            <Form onSubmit={handleSubmit}>
                <FormField
                    label=""
                    name="phone"
                    onChange={onPhoneChangeWithValidate}
                    placeholder="(211) 222-3333"
                    required
                    type="tel"
                    value={phone}
                    pattern="\([2-9][0-9]{2}\) [0-9]{3}-[0-9]{4}"
                />
                <div className={"buttons"}>
                    {/* <Button text={skipText} onClick={skipLogin} /> */ }
                <Button primary text="submit" type="submit" />
                </div>
            </Form>
            <Divider>
                <div />
            </Divider>

        </Container>
    );
}

export default LogInSearch;
